<button mat-icon-button class="close-button" (click)="cerrar()">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>

<h1 mat-dialog-title class="titulo-dialog">
  <mat-icon>info</mat-icon>
  Qué contempla cada total
</h1>

<div mat-dialog-content class="contenido-ayuda">

  <p class="intro">
    Todos los totales se calculan sobre <b>los períodos que devuelve el filtro</b>,
    así que cambian al cambiar la búsqueda.
  </p>

  <!-- ============ INQUILINO ============ -->
  <h3 class="titulo-seccion" [class.destacada]="seccion === 'inquilino'">
    <mat-icon>request_quote</mat-icon> Cobranza al inquilino
  </h3>

  <div class="definicion">
    <span class="termino">Total devengado</span>
    <span class="detalle">
      Alquiler de los períodos <b>ya vencidos</b>, se hayan cobrado o no.
      Es lo que el inquilino debería haber pagado hasta hoy.
    </span>
  </div>

  <div class="definicion">
    <span class="termino">Total cobrado</span>
    <span class="detalle">
      Períodos <b>con fecha de pago</b>. Incluye pagos adelantados, así que puede
      contener períodos que todavía no vencieron.
    </span>
  </div>

  <div class="definicion">
    <span class="termino">Deuda del inquilino</span>
    <span class="detalle">
      Períodos <b>vencidos y sin pagar</b>. Es la mora real: lo único reclamable hoy.
      El contador de períodos que aparece al lado cuenta esos mismos.
    </span>
  </div>

  <div class="definicion">
    <span class="termino">Total a cobrar</span>
    <span class="detalle">
      Todo lo <b>impago</b>, hayan vencido o no. Es mayor que la deuda porque suma
      los períodos futuros del contrato.
    </span>
  </div>

  <div class="formula">
    <mat-icon>functions</mat-icon>
    Total cobrado + Total a cobrar = Total períodos
  </div>

  <!-- ============ PROPIETARIO ============ -->
  <h3 class="titulo-seccion" [class.destacada]="seccion === 'propietario'">
    <mat-icon>account_balance_wallet</mat-icon> Liquidación al propietario
  </h3>

  <div class="definicion">
    <span class="termino">Total liquidado</span>
    <span class="detalle">
      Períodos <b>con fecha de liquidación</b>: ya se le rindieron al propietario.
      Es el espejo de "Total cobrado" del inquilino.
    </span>
  </div>

  <div class="definicion">
    <span class="termino">Total por liquidar</span>
    <span class="detalle">
      Lo que <b>hoy se le puede rendir</b> al propietario y todavía no se rindió.
      El criterio <b>depende del tipo de liquidación del contrato</b>:
      <br>
      &bull; <b>Real:</b> sólo los períodos con fecha de pago. No se puede rendir
      plata que el inquilino no puso.
      <br>
      &bull; <b>Ficticia:</b> los períodos ya vencidos, se hayan cobrado o no. La
      inmobiliaria adelanta y le rinde igual.
      <br>
      En los dos casos quedan afuera los períodos futuros: todavía no se devengaron.
    </span>
  </div>

  <div class="definicion">
    <span class="termino">Devengado sin cobrar</span>
    <span class="detalle">
      Períodos <b>vencidos, impagos y sin liquidar</b> de contratos con liquidación
      <b>real</b>: primero hay que cobrarlos para poder rendirlos.
      <br>
      No aparece si no hay contratos de liquidación real en el filtro: en la
      ficticia lo impago ya cuenta dentro de "Total por liquidar".
    </span>
  </div>

  <div class="definicion">
    <span class="termino">Liquidado y cobrado</span>
    <span class="detalle">
      Se liquidó al propietario <b>y</b> el inquilino pagó. El circuito cerrado.
    </span>
  </div>

  <div class="definicion">
    <span class="termino">Liquidado sin cobrar</span>
    <span class="detalle">
      Se le rindió al propietario plata que <b>el inquilino todavía no pagó</b>.
      La inmobiliaria la adelantó, por eso se muestra en rojo.
    </span>
  </div>

  <div class="formula">
    <mat-icon>functions</mat-icon>
    Total liquidado + Total por liquidar + Devengado sin cobrar + Períodos futuros = Total períodos
  </div>

  <!-- ============ ADVERTENCIA ============ -->
  <div class="advertencia">
    <mat-icon>warning</mat-icon>
    <div>
      <b>El devengado no cierra contra la liquidación.</b>
      El devengado cuenta sólo lo vencido; los totales de liquidación se miden
      sobre todos los períodos del filtro, incluidos los que aún no vencieron.
      Comparar uno con otro da una diferencia que no es un error.
    </div>
  </div>

</div>

<div mat-dialog-actions class="acciones-dialog">
  <button mat-raised-button color="primary" (click)="cerrar()">
    <mat-icon>check</mat-icon> Entendido
  </button>
</div>
